export default "__VITE_ASSET__2c120b3c__"